var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "1eabf11259f95e183ef0a37e29a1a8b76fe4bd0a"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["marketing-js@when-i-work"] = {
  id: "1eabf11259f95e183ef0a37e29a1a8b76fe4bd0a"
};